import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, AwaitModules, ComponentSync, LL_H_C, ModuleFE_SyncManager_CSV } from '@nu-art/thunderstorm-frontend/index';
import './Page_Advisor.scss';
import { AdvisorColumn } from '../../panels/AdvisorColumn/AdvisorColumn.js';
import { ModuleFE_EMInterface, ModulePack_AdvisorStatic } from '@app/advisor-frontend';
import { ColumnKey_FloatingLeft, ColumnKey_FloatingMiddle, ColumnKey_FloatingRight, ColumnKey_LeftColumn, ColumnKey_MiddleColumn, ColumnKey_RightColumn } from '@app/advisor-v5-shared';
import { ModuleFE_AdvisorBoard } from '../../../_enum.js';
import { ToasterPortal_Vertical } from '@nu-art/toasting';
import { ToastFilter_AdvisorGeneral } from '../toast.js';
export class Page_Advisor extends ComponentSync {
    __onReadOnlyChanged() {
        this.forceUpdate();
    }
    __onBackgroundTasksChanged() {
        this.forceUpdate();
    }
    __onPathwayEndUpdated() {
        // if no protocol has ended ignore
        if (!ModuleFE_EMInterface.isPostDisposition())
            return;
        // update the component
        this.forceUpdate();
    }
    componentDidMount() {
        ModuleFE_AdvisorBoard.updateAdvisorMeasurements();
    }
    static ModuleToAwait = [
        ...ModulePack_AdvisorStatic,
    ];
    removeSelections = (e) => {
        const clickedElement = e.target;
        const canSelectClassNames = ['ts-textarea', 'ts-input']; // a user can select from all items that explicitly mentioned they are selectable and the following class names (input and text area)
        const canSelect = getComputedStyle(clickedElement).getPropertyValue('user-select') !== 'none' || canSelectClassNames.some(className => clickedElement.classList.contains(className));
        // fail fast if can select
        if (canSelect)
            return;
        // remove selection
        const selection = window.getSelection();
        // if no selection object was received or no selection on the screen quit
        if (!selection || !selection.toString().length)
            return;
        selection.removeAllRanges();
    };
    render() {
        const postDispo = ModuleFE_EMInterface.isPostDisposition();
        return _jsxs(LL_H_C, { id: 'page-advisor', onClickCapture: this.removeSelections, className: _className(postDispo && 'dispo-completed', ModuleFE_EMInterface.hasBackgroundTasks() && 'loading'), children: [_jsx(AdvisorColumn, { columnKey: ColumnKey_LeftColumn }), _jsx(AdvisorColumn, { columnKey: ColumnKey_MiddleColumn }), _jsx(AdvisorColumn, { columnKey: ColumnKey_RightColumn }), _jsx(AdvisorColumn, { columnKey: ColumnKey_FloatingLeft }), _jsx(AdvisorColumn, { columnKey: ColumnKey_FloatingMiddle }), _jsx(AdvisorColumn, { columnKey: ColumnKey_FloatingRight }), _jsx(ToasterPortal_Vertical, { verticalGap: 8, verticalPadding: 8, modelFilter: ToastFilter_AdvisorGeneral })] });
    }
}
export class ATS_Page_Advisor extends ComponentSync {
    static Screen = {
        name: 'Advisor Page',
        key: 'advisor-page',
        group: 'Components',
        renderer: this,
    };
    componentDidMount() {
        ModuleFE_EMInterface.startFirebaseListeners();
        ModuleFE_SyncManager_CSV.readyAllModules();
        // ModuleFE_EMInterface.syncSnapShot();
    }
    render() {
        return _jsx(AwaitModules, { modules: Page_Advisor.ModuleToAwait, children: _jsx(Page_Advisor, {}) });
    }
}
//# sourceMappingURL=Page_Advisor.js.map